// Module
var code = "<h2 class=\"interiorSectionHeading\"> How It Works… </h2> <p>Dismisses your monthly loan payments and the remainder of your loan.</p> <p><a class=\"more-link\" href=\"/manage/loan-forgiveness-discharge/death\">Learn more about Death Discharge</a></p> ";
// Exports
export default code;